module.exports = __webpack_public_path__ + "static/media/career.382860e9.jpg";